// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AccountBookOutlinedSvg from "@ant-design/icons-svg/es/asn/AccountBookOutlined";
import AntdIcon from '../components/AntdIcon';

var AccountBookOutlined = function AccountBookOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AccountBookOutlinedSvg
  }));
};

AccountBookOutlined.displayName = 'AccountBookOutlined';
export default React.forwardRef(AccountBookOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/AccountBookOutlined.js
// module id = 523
// module chunks = 0